import { Box, IconButton } from '@mui/material';
import { TextField } from '../textfield';
//icons
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { isEmpty, trim } from 'lodash';

interface Props {
  onSearch: () => void;
  onCancel?: () => void;
  fieldValue: string | null | undefined;
  label: string;
  size?: 'small' | 'medium';
}

export const InputSearchField = ({ onSearch, onCancel, fieldValue, label, size }: Props) => {
  return (
    <Box display="flex" alignItems="center" gap={2} height={'100%'}>
      <TextField size={size} value={fieldValue ?? ''} label={label} disabled />
      <IconButton onClick={onSearch} color="primary">
        <SearchIcon />
      </IconButton>
      {onCancel && (
        <IconButton onClick={onCancel} disabled={isEmpty(trim(fieldValue ?? undefined))} color="primary">
          <ClearIcon />
        </IconButton>
      )}
    </Box>
  );
};
